// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e95c19e6b2b5ff4a0267600621b67da0f5992b06/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};